// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3HEj-","selected":"Chip_selected__c_-EJ"};